/* tslint:disable */
/* eslint-disable */
/**
 * Umsatzcontrolling
 * Money
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StrategischerUmsatz
 */
export interface StrategischerUmsatz {
    /**
     * 
     * @type {number}
     * @memberof StrategischerUmsatz
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof StrategischerUmsatz
     */
    maschinenGruppe: string;
    /**
     * 
     * @type {number}
     * @memberof StrategischerUmsatz
     */
    idFirma: number;
    /**
     * Umsatz pro Monat (0-11) in Euro.
     * @type {Array<number>}
     * @memberof StrategischerUmsatz
     */
    werte: Array<number>;
}

/**
 * Check if a given object implements the StrategischerUmsatz interface.
 */
export function instanceOfStrategischerUmsatz(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "maschinenGruppe" in value;
    isInstance = isInstance && "idFirma" in value;
    isInstance = isInstance && "werte" in value;

    return isInstance;
}

export function StrategischerUmsatzFromJSON(json: any): StrategischerUmsatz {
    return StrategischerUmsatzFromJSONTyped(json, false);
}

export function StrategischerUmsatzFromJSONTyped(json: any, ignoreDiscriminator: boolean): StrategischerUmsatz {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'maschinenGruppe': json['maschinenGruppe'],
        'idFirma': json['idFirma'],
        'werte': json['werte'],
    };
}

export function StrategischerUmsatzToJSON(value?: StrategischerUmsatz | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'maschinenGruppe': value.maschinenGruppe,
        'idFirma': value.idFirma,
        'werte': value.werte,
    };
}

